/* Detach mobile bottom navigation from the auto-hiding header.
   This makes Favoris / Compte / Panier genuinely permanent. */
(function(){
  function detach(){
    var bar=document.querySelector('.bdf-mobile-bottom');
    if(!bar)return;
    if(bar.parentElement!==document.body){document.body.appendChild(bar)}
    bar.classList.add('is-bdf-detached');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',detach);else detach();
  window.addEventListener('resize',function(){if(window.innerWidth<=768)detach()},{passive:true});
})();
